<template>
   <!--
   <div id="app">
   -->
      <nav class="navbar navbar-expand-sm navbar-dark bg-dark p-0">
         <div class="container-fluid">

            <a class="navbar-brand" href="/">
               <img src="./assets/logonavbar.png" width="30" height="30" class="d-inline-block align-top" alt="">
               Osplad - TAD
            </a>

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" 
                     data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" 
                     aria-expanded="false" aria-label="Toggle navigation">
               <span class="navbar-toggler-icon"></span>
            </button>
        
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
               <ul class="navbar-nav me-auto">
                  <li v-if="currentModule" class="nav-item">
                     <button class="btn btn-dark" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasApp" aria-controls="offcanvasApp" id="btnMenu">
                        <font-awesome-icon icon="bars" />
                        {{currentModule.appModule.name}}
                     </button>
                  </li>
               </ul>

               <ul class="navbar-nav d-flex">
                  {{countDown}}
                  <li v-if="!currentUser" class="nav-item">
                     <router-link to="/register" class="nav-link">
                        <font-awesome-icon icon="user-plus" /> 
                        Registrarse 
                     </router-link>
                  </li>
                  <li v-if="!currentUser" class="nav-item">
                     <router-link to="/login" class="nav-link">
                        <font-awesome-icon icon="sign-in-alt" /> 
                        Conectarse 
                     </router-link>
                  </li>
                  <!-- Modulos -->
                  <li v-if="currentUser" class="nav-item">
                     <router-link to="/userAppModules" class="nav-link">
                        <font-awesome-icon icon="th" />
                        Modulos 
                     </router-link>
                  </li>
                  
                  <li v-if="currentUser" class="nav-item dropdown">
                     <a class="nav-link" href="#" id="navbarDarkDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <font-awesome-icon icon="user" /> 
                        {{currentUser.username}}
                     </a>
                     <ul class="dropdown-menu dropdown-menu-dark dropdown-menu-end" aria-labelledby="navbarDarkDropdownMenuLink">
                        <li>
                        <a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#changePassModal">
                           <font-awesome-icon icon="key" /> 
                           Cambiar Contraseña
                        </a>
                        </li>
                        <li><hr class="dropdown-divider"></li>
                        <li>
                           <a class="dropdown-item" @click.prevent="logOut">
                              <font-awesome-icon icon="sign-out-alt" /> 
                              Desconectarse
                           </a>
                        </li>
                     </ul>
                  </li>
                  <MdChangePass v-if="currentUser" />
               </ul>
            </div>
         </div>
      </nav>
      <!-- Menu -->
      <div v-if="currentModule" class="offcanvas offcanvas-start" style="width: 250px;" data-bs-scroll="true" tabindex="-1" id="offcanvasApp" aria-labelledby="offcanvasApp">
         <div class="offcanvas-header">
            <h5 class="offcanvas-title" 
               id="offcanvasApp"
               :title=" currentModule.appModule.name + ` (` + currentModule.appModule.id + `)` "
               >
               {{currentModule.appModule.name}}
            </h5>
            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
         </div>
         <div class="offcanvas-body">
            <ul class="nav flex-column">
               <li class="nav-item" v-for="(component, index) in currentModule.appModuleComponent" :key="index">
                  <!--
                  -->
                  <button type="button" class="btn btn-link btn-sm"
                           data-bs-dismiss="offcanvas"
                           v-on:click="addComponent(component, index)"
                           :title=" component.nameInModule + ` [` + component.id + `]` "
                           >
                     {{component.nameInModule}}
                  </button>
               </li>
            </ul>
            <!-- {{currentModule}} -->
         </div>
      </div>
      <!-- -->
      <div class="routerView">
         <router-view />
      </div>
   <!--
                     {{index}} - {{component.nameInModule}}
            {{currentModule}}
   </div>
   -->
</template>

<script>
import AuthService from './services/auth.service';
import MdChangePass from './components/MdChangePass.vue';

export default {
   components: {
      MdChangePass
   },
   data() {
      return {
         countDown : 0,
      };
   },
   computed: {
      currentUser() {
         return this.$store.state.auth.user;
      },
      currentModule() {
         return this.$store.state.auth.userAppModule;
      },
   },
   created() {
      if (!this.currentUser) {
         this.$router.push("/login");
      }
      this.countDownTimer();
      if (this.currentUser) {
         this.$router.push("/profile");
      }
   },
   methods: {
      countDownTimer() {
         if(this.countDown > 0) {
            setTimeout(() => {
               this.countDown -= 1
               this.countDownTimer()
            }, 7500)   // 15000
         } else {
            //
            if (this.currentUser) {
               AuthService.kaUser(this.currentUser.id)
               //
               .then(response => {
                  //console.log('keep alive OK');
                  //console.log(response.data);
                  if ( !response.data ) {
                     this.logOut();
                     window.location.reload();
                  }
               })
               //
               .catch(error => {
                  //console.log('keep alive ERROR');
                  console.log(error);
                  this.logOut();
                  window.location.reload();
               });         
            }
            //
            //this.logOut();
            this.countDown = 4;
            this.countDownTimer();
         }
      },

      logOut() {
         this.$store.dispatch('auth/logout');
         this.$store.dispatch('auth/moduleOut');
         this.$router.push('/login');
      },
     
      addComponent(component, index) {
         console.log(component.appComponent);
         let rPath = component.relativePath;
         this.$router.addRoute({
            component: () => import(`/src/${rPath}/${component.appComponent}.vue`),
            path: component.ruterPath
         })
         console.log(index);
         this.$store.dispatch("auth/userAppIndex", index);
         console.log(this.$store.state.auth.userAppIndex);
         this.$router.push(component.ruterPath);
      }
   }
};
</script>

<style scoped>
.btn-link {
   text-decoration-line: none;
}
</style>

<style>
.mt-20 {
margin-top: 20px;
}
.mt-10 {
margin-top: 10px;
}
</style>
